import { Skeleton } from '@/shared/components/ui/skeleton'
import React from 'react'

export const CategoryTagsSkeleton: React.FC = () => {
  return (
    <div className="flex w-full flex-col items-center justify-center rounded-[20px_20px_0px_0px] px-4 pb-6 pt-8 max-md:max-w-full sm:px-6 sm:pb-8 sm:pt-12 md:px-8">
      <div className="flex max-w-full flex-col items-center font-medium text-mydra-gray">
        <div className="w-full whitespace-nowrap text-sm leading-none tracking-[-0.24px]">
          <div className="flex w-full flex-col items-center max-md:max-w-full">
            <div className="flex flex-wrap justify-center gap-2 max-md:max-w-full">
              {Array.from({ length: 8 }).map((_, idx) => (
                <Skeleton key={idx} className="h-8 w-24 rounded-[40px]" />
              ))}
            </div>
          </div>
        </div>
        <Skeleton className="mt-6 h-4 w-96 max-md:w-72" />
      </div>
    </div>
  )
}
